import "./index.styl";

import MessageView from "./_resources/message.js";
import ServersView from "./servers/servers.js";
import PagesView from "./pages/pages.js";
import Audit from "./audit/audit.js";
import UserLogin from "./auth/user-login.js";
import { augmentD3SelectionPrototypeForEasierSyntax } from "./_resources/d3selectionPlugins.js";
import FilesView from "./files/files.js";
import UrlonSectionView from "./urlon/UrlonSectionView.js";
import { getTab, saveTab } from "./_resources/url-state.js";

augmentD3SelectionPrototypeForEasierSyntax();

// Theme toggle — cycles: light → dark → auto → light …
(function initTheme() {
  const systemLight = window.matchMedia("(prefers-color-scheme: light)");

  const ICONS  = { light: "☀️",          dark: "🌙",         auto: "⛅" };
  const LABELS = { light: "☀️ Light theme", dark: "🌙 Dark theme", auto: "⛅ Theme follows your system" };

  function getState() {
    const saved = localStorage.getItem("theme");
    return saved === "light" || saved === "dark" ? saved : "auto";
  }

  function applyTheme(state) {
    const isLight = state === "light" || (state === "auto" && systemLight.matches);
    if (isLight) {
      document.documentElement.setAttribute("data-theme", "light");
    } else {
      document.documentElement.removeAttribute("data-theme");
    }
    const btn = document.getElementById("themeToggle");
    if (btn) btn.textContent = ICONS[state];
  }

  // Apply on load
  applyTheme(getState());

  // Follow system changes when in auto mode
  systemLight.addEventListener("change", () => {
    if (getState() === "auto") applyTheme("auto");
  });

  const btn = document.getElementById("themeToggle");
  if (!btn) return;
  btn.addEventListener("click", () => {
    const next = { light: "dark", dark: "auto", auto: "light" }[getState()];
    if (next === "auto") {
      localStorage.removeItem("theme");
    } else {
      localStorage.setItem("theme", next);
    }
    applyTheme(next);
    // show a brief info toast — views.message is available after main() runs
    views.message?.info(LABELS[next], 2000);
  });
})();

const urlParams = new URLSearchParams(document.location.search);
const state = {
  token: null,
  user_id: null
}
const views = {};

async function main() {

  views.message = new MessageView({ dom: ".message" } );
  new UserLogin({ dom: ".app-user-login", message: views.message, onAuthStateChange });
  views.servers = new ServersView({ dom: ".admin-stage#servers", message: views.message, getToken: () => state.token, getUserId: () => state.user_id });
  views.pages = new PagesView({ dom: ".admin-stage#pages", message: views.message, getToken: () => state.token, getUserId: () => state.user_id });
  views.audit = new Audit({ dom: ".admin-stage#audit", message: views.message, getToken: () => state.token });
  views.files = new FilesView({ dom: ".admin-stage#files", message: views.message, getToken: () => state.token });
  views.urlon = new UrlonSectionView({ dom: d3.select(".admin-stage#urlon .contentSection") });

  //initial tab
  //setTab();
}
main().catch(err => {
  console.error(err);
  d3.select(".admin-stage#servers").text(`Error: ${err.message || err}`);
});



function setTab(target) {
  // URL > localStorage > default "pages"
  if (target == null) target = getTab('pages');

  // Redirect to audit/ask if ?ask= param present and no explicit tab in URL
  if (!urlParams.get("tab")) {
    const askParam = urlParams.get("ask");
    if (askParam && state.token) {
      target = "audit";
      urlParams.set("tab", "audit");
      urlParams.set("subtab", "ask");
      history.replaceState(null, "", "?" + urlParams);
    }
  }
  
  d3.select('.admin-top-nav').selectAll(".nav-item").classed("active", false);
  d3.select('.admin-top-nav').select(".nav-item#" + target).classed("active", true);
  d3.selectAll(".admin-stage").style("display", "none");
  if (state.token) { 
    d3.select(".admin-stage#" + target).style("display", null);
    views[target]?.render && views[target].render();
  } else {
    views.message.progress(`Hello! Please log in or create an account to continue`);
  }
}



// Listen to buttons in sidebar
d3.select('.admin-top-nav').selectAll(".nav-item").on("click", function(e) {
  const navEl = d3.select(this);
  const target = navEl.attr("data-route");
  saveTab(target);
  urlParams.set("tab", target);
  history.pushState(null, "", "?" + urlParams); 
  setTab(target);
});



function onAuthStateChange ({event, session}) {
  const newToken = session?.access_token;
  if(state.token === newToken) return console.log(event, "✅ no token change");
  console.log(event);
  if(event === "SIGNED_IN") views.message.good(`Welcome, ${session?.user?.email?.split("@")[0]}! You are now logged in.`, 3000);

  state.token = newToken;
  state.user_id = session?.user?.id;
  setTab();
};



// Handle browser back/forward buttons
window.addEventListener('popstate', () => {
  const params = new URLSearchParams(location.search);
  const tab = params.get("tab");
  setTab(tab)
});





